/**
 * Google Ads & Analytics Tracking Utilities
 * Handles UTM parameters, gclid, and event tracking
 */

// Capture UTM parameters and gclid from URL
export const captureTrackingParams = () => {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    utm_source: urlParams.get('utm_source') || null,
    utm_medium: urlParams.get('utm_medium') || null,
    utm_campaign: urlParams.get('utm_campaign') || null,
    utm_term: urlParams.get('utm_term') || null,
    utm_content: urlParams.get('utm_content') || null,
    gclid: urlParams.get('gclid') || null,
    timestamp: new Date().toISOString(),
    landing_page: window.location.pathname
  };
};

// Store tracking params in sessionStorage
export const storeTrackingParams = () => {
  if (typeof window === 'undefined') return;
  
  const existing = sessionStorage.getItem('tracking_params');
  if (existing) return; // Don't overwrite
  
  const params = captureTrackingParams();
  if (params) {
    sessionStorage.setItem('tracking_params', JSON.stringify(params));
  }
};

// Get stored tracking params
export const getTrackingParams = () => {
  if (typeof window === 'undefined') return null;
  
  const stored = sessionStorage.getItem('tracking_params');
  return stored ? JSON.parse(stored) : null;
};

// Track Google Ads / GA4 events
export const trackEvent = (eventName, eventData = {}) => {
  if (typeof window === 'undefined') return;
  
  // Google Analytics 4
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }
  
  // Console log for debugging (remove in production if needed)
  console.log('🎯 Event Tracked:', eventName, eventData);
};

// Rewire-specific tracking events
export const trackRewiringEvents = {
  // Page view
  pageView: (page) => {
    trackEvent('rewire_page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: page
    });
  },
  
  // Calculator interactions
  calculatorStarted: () => {
    trackEvent('rewire_calculator_started', {
      page_location: window.location.href
    });
  },
  
  calculatorCompleted: (propertyDetails) => {
    trackEvent('rewire_calculator_completed', {
      property_type: propertyDetails.propertyType,
      bedrooms: propertyDetails.bedrooms,
      price_shown: propertyDetails.priceShown
    });
  },
  
  // Quote form interactions
  quoteStarted: () => {
    trackEvent('rewire_quote_started', {
      page_location: window.location.href
    });
  },
  
  quoteSubmitted: (leadData) => {
    trackEvent('rewire_quote_submitted', {
      property_type: leadData.propertyType,
      bedrooms: leadData.bedrooms,
      postcode: leadData.postcode,
      value: leadData.estimatedValue || 0
    });
  },
  
  // Click tracking
  phoneClick: (source) => {
    trackEvent('rewire_phone_click', {
      source: source,
      phone_number: '07711233685'
    });
  },
  
  whatsappClick: (source) => {
    trackEvent('rewire_whatsapp_click', {
      source: source,
      phone_number: '07711233685'
    });
  }
};

// Initialize tracking on page load
export const initializeTracking = () => {
  if (typeof window === 'undefined') return;
  
  // Store tracking params from URL
  storeTrackingParams();
  
  // Track initial page view if on rewire pages
  const rewiringPages = ['/rewiring', '/rewire-quote', '/house-rewiring'];
  if (rewiringPages.some(page => window.location.pathname.includes(page))) {
    trackRewiringEvents.pageView(window.location.pathname);
  }
};
